// @flow strict

import * as React from 'react';

import classNames from '@ta/common.classnames';
import { featureIsEnabled } from '@ta/common.features';
import Icon from '@ta/core-ui.icon';
import { Device } from '@ta/lithium.context';

import styles from './EncircledBookmarkIcon.css';

type Props = {|
  iconShape?: 'heart' | 'bookmark',

  /** If the bookmark appears active or not */
  active: boolean,

  /** If the bookmark should be displayed in hovering state or not */
  hovered?: boolean,

  /** Callback when the encircled bookmark icon is clicked */
  onClick?: (SyntheticEvent<*>) => void,
|};

const EncircledBookmarkIcon = (props: Props) => {
  const { viewportCategory } = React.useContext(Device);

  return (
    <span
      className={classNames(styles.encircled_bookmark, styles.ripple, {
        [styles.active]: props.active,
        [styles.hovered]: props.hovered,
        [styles.hoverable]: viewportCategory !== 'MOBILE',
        [styles.heart]: props.iconShape === 'heart',
      })}
      onClick={props.onClick}
    >
      <Icon name={props.iconShape === 'heart' ? 'heart-fill' : 'bookmark-fill'} />
    </span>
  );
};

EncircledBookmarkIcon.defaultProps = {
  iconShape: featureIsEnabled('trips_saves_heart') ? 'heart' : 'bookmark',
  onClick: undefined,
  hovered: false,
};

export default EncircledBookmarkIcon;
